<template>
  <div class="login_register">
    <img class="login_logo" :src="loginImg" alt="" />
    <div class="login_info">
      <div class="login_info_left">
        <div class="info_title">联帮帮网络货运平台</div>
        <img
          class="info_img"
          src="../../assets/login/img_denglu_nor@2x.png"
          alt=""
        />
      </div>
      <div class="login_info_right">
        <div class="login_info_one">
          <img
            class="info_one_img"
            src="../../assets/login/img_zhuangshi_nor@2x.png"
            alt=""
          />
        </div>
        <div class="login_info_two">
          <el-form
            ref="form"
            class="login-form"
            :model="form"
            :rules="regRules"
            autocomplete="on"
            label-position="left"
          >
            <div class="title-container" v-if="false">
              <h3 class="title">
                <img :src="loginImg" />
              </h3>
              <lang-select class="set-language" />
            </div>

            <div class="login-form_title">注册</div>
            <el-form-item prop="name">
              <span class="svg-container">
                <svg-icon icon-class="user" />
              </span>
              <el-input
                v-model="form.name"
                class="elInput"
                :placeholder="$t('register.name')"
                type="text"
              />
            </el-form-item>
            <el-form-item prop="phone">
              <span class="svg-container">
                <svg-icon icon-class="phone" />
              </span>
              <el-input
                v-model="form.phone"
                class="elInput"
                :placeholder="$t('register.phone')"
                type="text"
                :maxlength="11"
              />
            </el-form-item>
            <input
              type="text"
              style="position: fixed; z-index: -999; opacity: 0"
            />
            <el-form-item prop="upass">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                :key="passwordType"
                v-model="form.upass"
                class="elInput"
                name="password"
                :type="passwordType"
                :placeholder="$t('register.pwd')"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon
                  :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
                />
              </span>
            </el-form-item>
            <el-form-item prop="confpwd" style="margin-bottom: 10px">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                :key="passwordType"
                v-model="form.confpwd"
                class="elInput"
                name="password"
                :type="passwordType"
                :placeholder="$t('register.quepwd')"
                tabindex="2"
                autocomplete="on"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon
                  :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
                />
              </span>
            </el-form-item>
            <!-- <el-radio-group v-model="form.partyType">
              <el-radio
                v-for="(radio, index) in radioOptions"
                :key="index"
                :disabled="!show"
                :label="radio.label"
              >
                {{ radio.name }}
              </el-radio>
            </el-radio-group> -->
            <!-- <el-form-item
              v-if="form.partyType === 2 || form.partyType === 3"
              prop="branchCode"
            >
              <span class="svg-container">
                <svg-icon icon-class="list" />
              </span>
              <el-select
                v-model="form.branchCode"
                placeholder="请选择机构"
                class="branchInput"
                :disabled="!show"
                clearable
                style="width: 80%"
                @change="setPartyGroupCode"
              >
                <el-option
                  v-for="item in partyGroupList"
                  :key="item.code"
                  :label="item.groupName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item> -->
            <el-form-item prop="verifyCode">
              <el-row style="display: flex; align-items: center">
                <el-col :span="15">
                  <div class="grid-content bg-purple">
                    <span class="svg-container">
                      <svg-icon icon-class="phone" />
                    </span>
                    <el-input
                      v-model="form.verifyCode"
                      class="elInput"
                      maxlength="20"
                      :placeholder="$t('register.phonecode')"
                      type="text"
                    />
                  </div>
                </el-col>
                <el-col :span="6">
                  <div
                    class="grid-content bg-purple-light"
                    style="display: inline-block; text-align: right"
                  >
                    <el-button
                      :disabled="!show"
                      type="primary"
                      round
                      class="on_button "
                      size="mini"
                      style="
                        color: rgba(255, 255, 255, 0.9);
                        background: linear-gradient(
                          90deg,
                          #4283f4 0%,
                          #61a2f9 100%
                        );
                      "
                      @click="getCode"
                    >
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">{{ count }} s</span>
                    </el-button>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>

            <el-button
              type="primary"
              class="on_button sub_bottom"
              style="
                background: linear-gradient(188deg, #61a1f9 0%, #3d82ee 100%);
                border-radius: 6px 6px 6px 6px;
              "
              @click="registerbut('form')"
            >
              {{ $t("register.register") }}
            </el-button>
            <el-row v-if="false">
              <el-col :span="24">
                <el-checkbox v-model="checked"> 我已阅读并同意 </el-checkbox>
                <div class="zhengce" @click="service()">《服务协议》</div>
                <div class="zhengce" @click="Privacy()">《隐私协议》</div>
              </el-col>
            </el-row>
            <div class="go_register">
              <div class="register_box" @click="goPage('/login')">
                <div class="register_warn">已有账号？</div>
                <div class="register_button">去登录</div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <vxe-modal
      v-model="verificationFlag"
      :show-header="false"
      title="验证码"
      width="450"
      height="300"
      resize
    >
      <verification ref="verificationRef" @receive="receive" @cancel="cancel" />
    </vxe-modal>
    <div class="footer">
      <!-- <img src="../../assets/login/footerimg.png" /> -->
    </div>
    <div class="filing">
      【鲁公网安备 *****号】  网站备案/许可证号:【鲁ICP备2022004558号-1】
      Copyright 2024 瑞源控股集团版权所有
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import LangSelect from "@/components/LangSelect";
import { checkPassword } from "@/utils/validate4Form.js";
import verification from "./components/verification.vue";
// update by JiaYK start 2021/10/26 13:10 注册时发送短信验证码与其他验证码区分开
// import { Verifyphone, register, Getverificationcode } from "@/api/user";
import { register, GetRegisterVerifycode } from "@/api/user";
// update by JiaYK end 2021/10/26 13:10 注册时发送短信验证码与其他验证码区分开
const Base64 = require("js-base64").Base64;

export default {
  components: { LangSelect, verification },
  data() {
    return {
      loginImg: "",
      Privacyurl:
        this.BASE_API_URL + "agreement/agreement.html?agreementType=12",
      url: this.BASE_API_URL + "agreement/agreement.html?agreementType=13",
      linkurl: this.BASE_API_URL,
      passwordType: "password",
      show: true,
      count: "",
      checked: true,
      timer: null,
      type: [],
      verificationFlag: false,
      form: {
        phone: "",
        name: "",
        verifyCode: "",
        upass: "",
        branchCode: "",
        partyType: 3,
        imageCode: ""
      },
      cationCode: {
        partyGroupCode: "",
        phone: "",
        imageCode: ""
      },
      imgurl: "",
      platformName: "",
      regRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        upass: [
          { required: false, message: "请输入密码", trigger: "blur" },
          { validator: checkPassword }
        ],
        confpwd: [
          { required: true, message: "请输入确认密码", trigger: "blur" }
        ],
        type: [{ required: true, message: "请勾选协议", trigger: "blur" }],
        branchCode: [{ required: true, trigger: "blur", message: "请选择机构" }]
      },
      partyGroupList: [],
      // 单选框的数据
      radioOptions: [
        // {
        //   label: 0,
        //   name: "承运人",
        // },
        // {
        //   label: 1,
        //   name: '车队物流公司'
        // },
        {
          label: 3,
          name: "委托人"
        }
        // {
        //   label: 3,
        //   name: "托运人",
        // },
      ],
      defaultBranchCode: ""
    };
  },
  created() {
    request({
      url: "/ntocc-basic-api/partyGroup/getDefault",
      method: "get"
    }).then(response => {
      this.defaultBranchCode = response.data.code;
      this.form.branchCode = response.data.code;
      this.loginImg = response.data.loginLogoUrl;
      this.$store.dispatch("enterprise/setEnterprise", response.data);
      localStorage.setItem("platformName", response.data.platformName);
      this.platformName = response.data.platformName || "网络货运平台";
      // document.title = response.data.groupName;
      // icon
      // document.querySelector('link[rel="icon"').href = response.data.subscript || ""
    });
    this.getPartyGroup();
  },
  methods: {
    goPage(redirect) {
      this.$router.push(redirect);
    },
    // 获取机构信息
    getPartyGroup() {
      request({
        url: "/ntocc-basic-api/partyGroup/list",
        method: "get"
      })
        .then(response => {
          this.partyGroupList = response.data;
          // 默认选中第一个
          this.form.branchCode = response.data[0].code;
        })
        .then(response => {});
    },
    service() {
      window.open(
        this.BASE_API_URL + "agreement/agreement.html?agreementType=13",
        "_blank"
      );
    },
    Privacy() {
      window.open(
        this.BASE_API_URL + "agreement/agreement.html?agreementType=12",
        "_blank"
      );
    },
    // 选择组织机构
    setPartyGroupCode(value) {
      this.form.branchCode = value;
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    },
    receive(imageCode) {
      this.cationCode.imageCode = imageCode;
      this.verificationFlag = false;
      // update by JiaYK start 2021/10/26 13:10 注册时发送短信验证码与其他验证码区分开
      GetRegisterVerifycode(this.cationCode).then(response => {
        // Getverificationcode(this.cationCode).then(response => {
        // update by JiaYK end 2021/10/26 13:11 注册时发送短信验证码与其他验证码区分开
        if (response.status == 0) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    cancel() {
      this.verificationFlag = false;
    },
    getCode() {
      const rLoading = this.openLoading();
      const pCode =
        this.form.partyType === 2 || this.form.partyType === 3
          ? this.form.branchCode
          : this.defaultBranchCode;
      this.verificationFlag = true;
      this.cationCode.partyGroupCode = pCode;
      this.cationCode.phone = this.form.phone;
      this.imgurl =
        `${this.linkurl}ntocc-tps-api/sms/getVerificationCodeImage?phone=` +
        this.cationCode.phone +
        "&imageWith=300&imageHeigth=100&t=" +
        new Date().getTime();
      this.$refs.verificationRef.getVerificationCodeImage(this.imgurl);
      rLoading.close();
      // Verifyphone({branchCode: pCode, phone: this.form.phone}).then(response => {
      //   if (response.status == 0) {
      //     this.cationCode.partyGroupCode = pCode
      //     this.cationCode.phone = this.form.phone
      //     if (!validatePhone(this.form.phone)) {
      //       this.$message.error("请输入正确的手机号");
      //       rLoading.close();
      //       return false;
      //     }
      //     this.verificationFlag = true
      //     this.imgurl = this.linkurl + 'ntocc-tps-api/sms/getVerificationCodeImage?phone=' + this.cationCode.phone + '&imageWith=300&imageHeigth=100&t=' + new Date().getTime()
      //     this.$refs.verificationRef.getVerificationCodeImage(this.imgurl)
      //     rLoading.close();
      //   }
      // });
    },
    //注册
    registerbut(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.form.upass != this.form.confpwd) {
            this.$message.error("两次密码输入不一致");
            return false;
          } else {
            if (this.checked == true) {
              let formData = Object.assign({}, this.form);
              formData.upass = Base64.encode(this.form.upass);
              formData.confpwd = Base64.encode(this.form.confpwd);
              register(formData).then(response => {
                if (response.status == 0) {
                  let formData = Object.assign({}, this.form);
                  formData.upass = Base64.encode(this.form.upass);
                  formData.confpwd = Base64.encode(this.form.confpwd);
                  this.$router.push({
                    path: "/login"
                  });
                } else {
                  this.$message({ message: response.msg, type: "success" });
                }
              });
              // Verifyphone({branchCode: pCode, phone: this.form.phone}).then(response => {
              //   if (response.status == 0) {
              //     let formData = Object.assign({}, this.form)
              //     formData.upass = Base64.encode(this.form.upass)
              //     formData.confpwd = Base64.encode(this.form.confpwd)
              //     register(formData).then(response => {
              //       if (response.status == 0) {
              //         this.$router.push({
              //           path: "/login"
              //         });
              //       } else {
              //         this.$message({message: response.msg, type: "success"});
              //       }
              //     });
              //   }
              // });
            } else {
              this.$message.error("请查看相关协议，并勾选");
            }
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
$bg: #283443;
$light_gray: #000;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login_register .elInput input {
    color: $cursor;
  }
}

@media screen and (min-width: 1900px) {
  /* reset element-ui css */
  .login_register {
    .elInput {
      display: inline-block;
      height: 47px;
      width: 80%;

      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: $light_gray;
        height: 47px;
        caret-color: $cursor;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px $bg inset !important;
          -webkit-text-fill-color: $cursor !important;
        }
        &:-webkit-autofill,
        textarea:-webkit-autofill,
        select:-webkit-autofill {
          -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
          background-color: transparent;
          background-image: none;
          transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
        }
      }
    }

    .el-form-item {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: #fff;
      border-radius: 5px;
      color: #454545;
    }
  }
}
@media screen and (max-width: 1900px) {
  /* reset element-ui css */
  .login_register {
    .elInput {
      display: inline-block;
      height: 34px;
      width: 75%;

      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: $light_gray;
        height: 34px;
        caret-color: $cursor;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px $bg inset !important;
          -webkit-text-fill-color: $cursor !important;
        }
        &:-webkit-autofill,
        textarea:-webkit-autofill,
        select:-webkit-autofill {
          -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
          background-color: transparent;
          background-image: none;
          transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
        }
      }
    }

    .el-form-item {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: #fff;
      border-radius: 5px;
      color: #454545;
      margin-bottom: 15px;
      height: 34px;
    }
    .el-form-item__content {
      height: 34px;
      font-size: 16px;
    }

    .el-form-item__error {
      padding-top: 2px;
    }
  }
}
</style>

<style lang="scss" scoped>
$bg: #e7f0fe;
$dark_gray: #aaaaaa;
$light_gray: #eee;

@media screen and (min-width: 1900px) {
  .login_register {
    // min-height: 1000px;
    background-color: $bg;
    //overflow: hidden;
    // background: url('../../assets/login/loginimg.png');
    // background-size: 100% 100%;
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .login_logo {
      width: 104px;
      height: 38px;
      position: absolute;
      top: 26px;
      left: 51px;
    }
    .filing {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 30px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #8b929c;
      line-height: 16px;
    }
    .login_info {
      width: 1572px;
      height: 783px;
      background: #f3f6ff;
      display: flex;
      .login_info_left {
        flex: none;
        width: 794px;
        margin-left: 151px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .info_title {
          margin-top: 111px;
          font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
          font-weight: bold;
          font-size: 36px;
          color: #4589f0;
          line-height: 42px;
          text-align: center;
        }
        .info_img {
          margin-top: 8px;
          width: 794px;
          height: 559px;
        }
      }
      .login_info_right {
        flex: 1;
        height: 783px;
        background: #f9fbfe;
        position: relative;
        .login_info_one {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-end;
          .info_one_img {
            width: 396px;
            height: 230px;
          }
        }
        .login_info_two {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
    .login-form {
      position: relative;
      width: 312px;
      max-width: 100%;
      // padding: 160px 35px 0;
      margin: 0 auto;
      overflow: hidden;

      .login-form_title {
        width: 100%;
        text-align: center;
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 36px;
        color: #4589f0;
        line-height: 42px;
        margin-top: 140px;
        margin-bottom: 34px;
      }
      .on_button {
        width: 95px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          opacity: 0.8;
        }
      }
      .sub_bottom {
        width: 312px;
        height: 40px;
      }
      .go_register {
        margin-top: 30px;
        width: 100%;
        display: flex;
        justify-content: center;
        .register_box {
          width: 137px;
          height: 28px;
          background: #e8edf4;
          border-radius: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
          .register_warn {
          }
          .register_button {
            color: #4186ef;
          }
        }
      }
    }

    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 6px 5px 6px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      font-size: 18px;
      display: inline-block;
    }

    .title-container {
      position: relative;

      .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0px auto 40px auto;
        text-align: center;
        font-weight: bold;

        img {
          width: 80%;
        }
      }

      .set-language {
        color: #fff;
        position: absolute;
        top: 3px;
        font-size: 18px;
        right: 0px;
        cursor: pointer;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }

    .thirdparty-button {
      position: absolute;
      right: 0;
      bottom: 6px;
    }

    @media only screen and (max-width: 470px) {
      .thirdparty-button {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 1900px) {
  .login_register {
    min-height: 500px;
    background-color: $bg;
    //overflow: hidden;
    // background: url('../../assets/login/loginimg.png');
    // background-size: 100% 100%;
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .login_logo {
      width: 104px;
      height: 38px;
      position: absolute;
      top: 0.68vw;
      left: 2.66vw;
    }
    .filing {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 1vw;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #8b929c;
      line-height: 16px;
    }
    .login_info {
      width: 83.31vw;
      height: 41.43vw;
      min-height: 566px;
      min-width: 1138px;
      background: #f3f6ff;
      display: flex;
      .login_info_left {
        flex: none;
        width: 48.46vw;
        padding-left: 6.66vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        .info_title {
          margin-top: 5.86vw;
          font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
          font-weight: bold;
          font-size: 26px;
          color: #4589f0;
          line-height: 31px;
          text-align: center;
        }
        .info_img {
          margin-top: 0.95vw;
          width: 40.48vw;
          height: 28.55vw;
          min-width: 553px;
          min-height: 390px;
        }
      }
      .login_info_right {
        flex: 1;
        height: 41.43vw;
        min-height: 566px;
        background: #f9fbfe;
        position: relative;
        .login_info_one {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-end;
          .info_one_img {
            width: 396px;
            height: 230px;
          }
        }
        .login_info_two {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
    .login-form {
      position: relative;
      width: 226px;
      max-width: 100%;
      // padding: 160px 35px 0;
      margin: 0 auto;
      overflow: hidden;

      .login-form_title {
        width: 100%;
        text-align: center;
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 26px;
        color: #4589f0;
        line-height: 2.19vw;
        margin-top: 7.9vw;
        margin-bottom: 2.12vw;
      }
      .on_button {
        width: 80px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          opacity: 0.8;
        }
      }
      .sub_bottom {
        width: 225px;
        height: 34px;
      }
      .go_register {
        margin-top: 1vw;
        width: 100%;
        display: flex;
        justify-content: center;
        .register_box {
          width: 137px;
          height: 28px;
          background: #e8edf4;
          border-radius: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
          .register_warn {
          }
          .register_button {
            color: #4186ef;
          }
        }
      }
    }

    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 0px 5px 0px 15px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      // font-size: 18px;
      display: inline-block;
    }

    .title-container {
      position: relative;

      .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0px auto 40px auto;
        text-align: center;
        font-weight: bold;

        img {
          width: 80%;
        }
      }

      .set-language {
        color: #fff;
        position: absolute;
        top: 3px;
        font-size: 18px;
        right: 0px;
        cursor: pointer;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }

    .thirdparty-button {
      position: absolute;
      right: 0;
      bottom: 6px;
    }

    @media only screen and (max-width: 470px) {
      .thirdparty-button {
        display: none;
      }
    }
  }
}

.footer {
  position: fixed;
  bottom: 50px;
  left: 50%;
  margin-left: -100px;

  img {
    width: 70%;
  }
}

.bg-purple-light {
  span {
    color: #fff;
    // line-height: 50px;
    font-size: 13px;
    text-align: right;
    display: block;
  }
}

.el-radio-group {
  margin: 10px 0;
}

::v-deep.el-input.is-disabled .el-input__inner {
  background: transparent;
  border: none;
  line-height: 34px;
}

::v-deep .el-radio__input.is-disabled.is-checked .el-radio__inner {
  background: #1890ff;
}

.branchInput ::v-deep .el-input--medium .el-input__inner {
  background: transparent;
  border: none;
}

.el-radio__inner {
  background-color: #f00;
}

.zhengce {
  display: inline-block;
  font-size: 13px;
  color: #1890ff;
}
</style>
